import React from "react";
import { withTranslation } from "react-i18next";

import { windFlowCardinal } from "../../utils/windDirection";
import { nearestWeatherAt } from "./fieldAppWeather";
import "./FieldAppTrackingWeatherHud.css";

function FieldAppTrackingWeatherHud({
  series,
  fallbackSeries,
  timeMs,
  maxAgeMs,
  t,
}) {
  const weather =
    nearestWeatherAt(series, timeMs, maxAgeMs) ||
    nearestWeatherAt(fallbackSeries, timeMs, maxAgeMs);
  if (!weather) return null;

  const deg = Number(weather.windDeg);
  const flowCardinal = Number.isFinite(deg)
    ? windFlowCardinal(deg)
    : weather.windCardinal || "";
  const temp = Number.isFinite(Number(weather.temperatureC))
    ? Math.round(Number(weather.temperatureC))
    : null;
  const speed = Number.isFinite(Number(weather.windSpeedKmh))
    ? Math.round(Number(weather.windSpeedKmh))
    : null;
  const humidity = Number.isFinite(Number(weather.humidity))
    ? Math.round(Number(weather.humidity))
    : null;
  if (temp == null && speed == null && humidity == null) return null;

  return (
    <div
      className="field-app-tracking-weather-hud"
      aria-label={t("Clima no instante do mapa")}
    >
      {temp != null ? (
        <div className="field-app-tracking-weather-hud__temp">{temp}°</div>
      ) : null}
      <svg
        className="field-app-tracking-weather-hud__arrow"
        viewBox="0 0 64 64"
        style={{
          transform: `rotate(${
            Number.isFinite(deg) ? (deg + 180) % 360 : 0
          }deg)`,
        }}
        aria-hidden="true"
      >
        <path d="M32 6 L44 38 L32 32 L20 38 Z" fill="currentColor" />
        <rect x="29.2" y="30" width="5.6" height="26" rx="1.2" fill="currentColor" />
      </svg>
      {speed != null ? (
        <div className="field-app-tracking-weather-hud__wind">
          {speed} km/h
          {flowCardinal ? ` ${flowCardinal}` : ""}
        </div>
      ) : null}
      {humidity != null ? (
        <div className="field-app-tracking-weather-hud__humidity">
          {humidity}% {t("UR")}
        </div>
      ) : null}
    </div>
  );
}

export default withTranslation()(FieldAppTrackingWeatherHud);
